import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import Time from "react-time-format";

class FormRprint extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { RB_data } = value;

            const wakil = RB_data.map((user, i) => {
              return (
                <tr
                  key={i}
                  className="f4 fk"
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black"
                  }}
                >
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    {user.nawiwargr}
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    <NumberFormat
                      value={user.nrxe_RRR}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    <NumberFormat
                      value={user.Krini_RRR}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    {user.joripara}
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    <NumberFormat
                      value={user.paraywargirawdolar}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    {user.nawishwen}
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    {user.shwencode}
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    <Time
                      value={user.date}
                      format="YYYY-MM-DD"
                      style={{ color: "black" }}
                    />
                  </td>
                  <td
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.3em",
                      color: "black"
                    }}
                  >
                    {user.zhmara}
                  </td>
                </tr>
              );
            });

            return (
              <table id="example" className="table table-striped  text-right ">
                <thead>
                  <tr
                    className="text-black f3 fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black"
                    }}
                  >
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      ناوی وەرگر
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      {" "}
                      RRR نرخ
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      {" "}
                      RRR کڕین
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      {" "}
                      دراو
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      کۆی پسوولە
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      ناوی بەرێز
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      ژ.بەرێز
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      بەروار
                    </th>
                    <th
                      className="f3"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray"
                      }}
                    >
                      ژمارە
                    </th>
                  </tr>
                </thead>
                <tbody>{wakil}</tbody>
              </table>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default FormRprint;
